import { useLayoutContext } from "../Contexts/LayoutContext";
import { useOrderTypeContext } from "../Contexts/OrderTypeContext";
import { useStoreContext } from "../Contexts/StoreContext";
import AddressService, { SearchProps } from "../Services/AddressService";
import { TokenManager } from "../Services/TokenManager";

export const useAddressHook = () => {

    const { currentAddress, setCurrentAddress } = useStoreContext();
    const { orderType } = useOrderTypeContext();
    const { setMainLoading } = useLayoutContext();

    const delayCreateAddress = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
    const handleCreateAddress = async (newAddress: any = currentAddress) => {
        await delayCreateAddress(300);

        if (!TokenManager.getToken() || !newAddress) return;

        try {
            const addressService = new AddressService(orderType);
            const response = await addressService.create(newAddress);
            if (response.address) {
                setCurrentAddress(response.address);
            }
            return response;
        } catch (error: any) {
            throw error;
        }
    };


    const search = async (params: SearchProps) => {
        try {
            const addressSevice = new AddressService(orderType);
            const getSearch = await addressSevice.search(params);
            return getSearch;
        } catch (error: any) {
            throw error;
        } finally {
            setMainLoading(false);
        }
    }

    return {
        handleCreateAddress,
        search
    };
}